<template>
  <el-dialog
    :width="$cache.local.get('locale') === 'vn' ? '1250px' : '1000px'"
    :title="$t('vipModule.couponDetailTitle')"
    append-to-body
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    @close="closeDialog">
    <section class="drawer-box" v-if="dataInfo">
      <div class="card">
        <div class="card-title row align-center">
          <i></i>
          <span>{{ $t('vipModule.couponInfoTitle') }}</span>
        </div>
        <div class="row align-center info-row">
          <div class="row align-center row-item">
            <span style="width:auto;">{{ $t('vipModule.couponTypeLabel') }}</span>
            <div>{{dataInfo.couponTypeName}}</div>
          </div>
          <div class="row align-center row-item">
            <span style="width:auto;">{{ $t('vipModule.couponSourceLabel') }}</span>
            <div>{{dataInfo.channelName}}</div>
          </div>
          <div class="row align-center row-item">
            <span style="width:auto;">{{ $t('vipModule.couponDiscountAmountLabel') }}</span>
            <div style="color: #F8475F;">***</div>
          </div>
        </div>
        <div class="row align-center info-row">
          <div class="row align-center row-item" style="flex: 2;">
            <span style="width:auto;">{{ $t('vipModule.couponNameLabel') }}</span>
            <div>{{dataInfo.name}}</div>
          </div>
          <div class="row align-center row-item">
            <span style="width:auto;">{{ $t('vipModule.couponVerifyTimeLabel') }}</span>
            <div>{{dataInfo.verifyTime}}</div>
          </div>
        </div>
        <div class="row align-center info-row" v-if="[0, 3].includes(dataInfo.couponType)">
          <div class="row align-center row-item" style="flex: 2;">
            <span style="width:auto;">{{ $t('vipModule.couponOrderMinCountLabel') }}</span>
            <div>{{dataInfo.countLimit}}</div>
          </div>
        </div>
        <div class="row align-center info-row" v-if="dataInfo.couponType === 1">
          <div class="row align-center row-item">
            <span style="width:auto;">{{ $t('vipModule.couponTagPriceDenominationLabel') }}</span>
            <div>***</div>
          </div>
        </div>
        <div class="row align-center info-row">
          <div class="row row-item">
            <span style="width:auto;">{{ $t('vipModule.couponDescriptionLabel') }}</span>
            <div style="white-space: pre-line;flex: 1;">{{dataInfo.remark}}</div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-title row align-center">
          <i></i>
          <span>{{ $t('vipModule.couponGoodsTitle') }}</span>
        </div>
        <el-table
          border
          :data="goodsList"
          :cell-style="{ padding: '10px 0' }"
          :header-cell-style="{ background: '#FAFAFA', color: '#436481' }">
          <el-table-column prop="goodsNo" :label="$t('vipModule.couponGoodsNoLabel')">
            <template slot-scope="scope">
              <div style="color:#1890ff;cursor:pointer;" @click="previewImage(scope.row.imageList)">{{scope.row.goodsNo}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="goodsName" :label="$t('vipModule.couponGoodsNameLabel')"></el-table-column>
          <el-table-column prop="number" :label="$t('vipModule.couponQuantityLabel')"></el-table-column>
          <template v-if="dataInfo.couponType === 1">
            <el-table-column prop="tagPrice" :label="$t('vipModule.couponTagPriceLabel')"></el-table-column>
          </template>
          <template v-else>
            <el-table-column prop="couponAmount" :label="$t('vipModule.couponSingleDiscountLabel')">
              <template slot-scope="scope">
                <div>***</div>
              </template>
            </el-table-column>
          </template>
          <el-table-column prop="realPrice" :label="$t('vipModule.couponActualPriceLabel')">
            <template slot-scope="scope">
              <div>***</div>
            </template>
          </el-table-column>
          <el-table-column prop="source" :label="$t('vipModule.couponColorSizeLabel')">
            <template slot-scope="scope">
              <span v-for="(attr, a) in scope.row.attr.slice(0, 2)">{{attr.value}}<i v-if="a===0">，</i></span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="card" v-if="giveList.length">
        <div class="card-title row align-center">
          <i></i>
          <span>{{ $t('vipModule.couponGiftsTitle') }}</span>
        </div>
        <el-table
          border
          :data="giveList"
          :cell-style="{ padding: '10px 0' }"
          :header-cell-style="{ background: '#FAFAFA', color: '#436481' }">
          <el-table-column prop="goodsNo" :label="$t('vipModule.couponGoodsNoLabel')">
            <template slot-scope="scope">
              <div style="color:#1890ff;cursor:pointer;" @click="previewImage(scope.row.imageList)">{{scope.row.goodsNo}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="goodsName" :label="$t('vipModule.couponGoodsNameLabel')"></el-table-column>
          <el-table-column prop="number" :label="$t('vipModule.couponQuantityLabel')"></el-table-column>
          <el-table-column prop="source" :label="$t('vipModule.couponColorSizeLabel')">
            <template slot-scope="scope">
              <span v-for="(attr, a) in scope.row.attr.slice(0, 2)">{{attr.value}}<i v-if="a===0">，</i></span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </section>
    <el-image-viewer v-if="showViewer" :zIndex="9999" :url-list="imageList" :on-close="closeViewer"></el-image-viewer>
  </el-dialog>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer"
export default {
  props: {
    dataInfo: {
      type: Object,
      default: () => null
    }
  },
  components: {
    ElImageViewer
  },
  data(){
    return {
      dialogVisible: true,
      imageList: [],
      showViewer: false,
      goodsList: [],
      giveList: []
    }
  },
  created() {
    if(this.dataInfo){
      this.goodsList = this.dataInfo.couponGoodsInfoList.filter(item => {
        return item.operationType !== '2'
      })
      this.giveList = this.dataInfo.couponGoodsInfoList.filter(item => {
        return item.operationType === '2'
      })
    }
  },
  methods:{
    closeDialog(){
      this.dialogVisible = false
      this.$emit('close')
    },
    previewImage(list){
      if(!list || (list && !list[0])) return this.$message.error(this.$t('vipModule.couponNoGoodsImageText'))
      this.imageList = list
      this.showViewer = true
    },
    closeViewer() {
      this.showViewer = false
    }
  }
}
</script>

<style lang="scss" scoped>
.drawer-box{
  margin-top: -20px;
  .card{
    margin-bottom: 20px;
    .card-title{
      margin-bottom: 10px;
      i{
        width: 4px;
        height: 18px;
        margin-right: 10px;
        background: #067cf2;
      }
      span{
        color: #000;
        font-size: 16px;
      }
    }
    .info-row{
      margin-top: 20px;
      .row-item{
        flex: 1;
        font-size: 15px;
        span{
          color: #666;
          width: 110px;
        }
      }
    }
  }
}
</style>